import React from "react";
import { produce } from "immer";
import { MultistepFilter } from "@sscs/ui";
import { InsightsFilters } from "../../types";
import { FILTER_TO_CATEGORY } from "../../utils";
import { useFilterOptions } from "./useFilterOptions";

type FilterProps = {
  filters: InsightsFilters;
  onFilterChange: (filters: InsightsFilters) => void;
};

const Filter = ({
  filters,
  onFilterChange,
}: FilterProps): React.JSX.Element | null => {
  const filterOptions = useFilterOptions();

  if (!filterOptions) return null;

  return (
    <MultistepFilter
      activeFilters={filters}
      filterOptions={filterOptions}
      onFilterSave={(filterName, filter) =>
        onFilterChange(
          produce(filters, (draft) => {
            draft[filterName] = filter;
          }),
        )
      }
      onFilterDelete={(filterName) =>
        onFilterChange(
          produce(filters, (draft) => {
            delete draft[filterName];
          }),
        )
      }
      groupFiltersBy={(filterName) => FILTER_TO_CATEGORY[filterName]}
    />
  );
};

export default Filter;
